import { useTranslation } from 'react-i18next'
import { X } from 'lucide-react'
import { introStepText, STEP_AREA, type IntroStepId } from '@/src/renderer/lib/intro'
import { useIntroTextOptions } from './useIntroTextOptions'
import './IntroTip.scss'

export interface IntroTipProps {
  /** Was erklärt wird. Ein Schritt: Bereich und Titel im Kopf. Mehrere: `heading` im Kopf, Titel je Absatz. */
  steps: readonly IntroStepId[]
  heading?: string
  onClose: () => void
}

/**
 * **Erklärung der Einführung** (#323) — Inhalt des großen Tooltips der Seitenhilfe und von „Entdecken“.
 * Kennt keine Hülle: Position, Pfeil, Esc und Klick daneben bringt das Popover mit, in dem er steht.
 *
 * @example
 * <IntroTip steps={['board']} onClose={close} />
 * <IntroTip steps={['quicknotes', 'quickadd', 'clarify']} heading="So geht „Kurz notiert“" onClose={close} />
 */
export function IntroTip({ steps, heading, onClose }: IntroTipProps) {
  const { t } = useTranslation()
  const options = useIntroTextOptions()
  const single = steps.length === 1 ? steps[0] : null

  return (
    <div className="intro-tip">
      <div className="intro-tip__head">
        {single ? (
          <>
            <span className="intro-tip__area">{t(`intro.area.${STEP_AREA[single]}`)}</span>
            <span className="intro-tip__title">{introStepText(t, single, 'title', options)}</span>
          </>
        ) : (
          <span className="intro-tip__title">{heading}</span>
        )}
        <button type="button" className="intro-tip__close" onClick={onClose} aria-label={t('intro.tip.close')}>
          <X size={14} />
        </button>
      </div>
      {steps.map(step => (
        <div key={step} className="intro-tip__item">
          {!single && <b className="intro-tip__item-title">{introStepText(t, step, 'title', options)}</b>}
          <p className="intro-tip__text">{introStepText(t, step, 'long', options)}</p>
        </div>
      ))}
    </div>
  )
}
